<template>
  <div>
    <p class="ywData_item_title">{{ tableData.module }}</p>
    <div class="ywData_item_content">
      <el-table :data="tableData.details" :show-header="false" :row-style="{ height: '28px' }" style="width: 100%" height="106">
        <el-table-column type="index" width="20"> </el-table-column>
        <el-table-column prop="name" label="名字" min-width="30" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.type == 'fjk'">
              <el-link type="primary" :underline="false" @click="uploadAttach(scope.row)">上传</el-link>
              <el-link type="primary" :underline="false" @click="showAttachGala(scope.row)" class="marginLeft20">附件库</el-link>
            </template>
            <template v-else>
              <el-link type="primary" :underline="false" @click="downTemp(scope.row)">模板</el-link>
              <el-link type="primary" :underline="false" @click="importTemp(scope.row)" class="marginLeft20">导入</el-link>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--导入模板-->
    <el-dialog
      width="50%"
      title="导入模板"
      class="sp-manager__dialog"
      :visible="importShow"
      :close-on-click-modal="false"
      :before-close="beforeCloseImport"
      @dialogclose="beforeCloseImport"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入模板</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        :expectParam="expectParam"
        limit="1"
        displayType="table"
        :importsuccess="true"
        :multiple="false"
        :importurl3="importUrl"
        :downloadable="false"
      >
        <span slot="labeldesc">导入模板</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeCloseImport">完 成</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      title="上传附件"
      class="sp-manager__dialog"
      :visible="importAttachShow"
      :close-on-click-modal="false"
      :before-close="beforeCloseImportAttach"
      @dialogclose="beforeCloseImportAttach"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">上传附件</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PNG,BMP,PDF,doc,docx,xls,xlsx"
        limit="50"
        displayType="table"
        :importsuccess="true"
        :multiple="true"
        :importurl5="importUrl"
        :downloadable="false"
        @input="input"
      >
        <span slot="labeldesc">上传附件</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeCloseImportAttach">完 成</el-button>
      </span>
    </el-dialog>
    <attach-library-table-dialog :show="libraryShow" :subType="subType" @closeD="closeD" />
  </div>
</template>

<script>
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
import AttachLibraryTableDialog from './attachLibraryTableDialog.vue'
import moment from 'moment'
export default {
  name: 'ywDataIndex',
  data() {
    return {
      importShow: false,
      libraryShow: false,
      importAttachShow: false,
      importUrl: '',
      subType: '',
      expectParam: {},
      fileList: []
    }
  },
  components: {
    eipImportMaterial,
    AttachLibraryTableDialog
  },
  props: {
    tableData: {
      type: Object,
      default() {
        return {
          details: [],
          module: ''
        }
      }
    }
  },
  methods: {
    closeD() {
      this.libraryShow = false
    },
    //附件库上传
    uploadAttach(row) {
      this.subType = row.subType
      this.fileList = []
      this.importUrl = `/system/file/v1/upload`
      this.importAttachShow = true
    },
    // 附件库查看
    showAttachGala(row) {
      this.subType = row.subType
      this.libraryShow = true
    },
    // 下载模板
    downTemp(row) {
      if (row.subType) {
        const url2 = '${data}/system/attachment_library/exportAttachmentLibrary'
        const params = {
          querys: [
            {
              group: 'advanced',
              operation: 'EQUAL',
              property: 'F_sub_type',
              relation: 'AND',
              value: row.subType
            }
          ],
          pageBean: {
            page: 1,
            pageSize: 500
          }
        }
        this.$http.post(url2, params, '', 'arraybuffer')
      } else {
        let url = '${business}' + `/system/context/template?fileKey=${row.downloadTemplate}`
        this.$http.get(url, 'arraybuffer')
      }
    },
    // 导入模板
    importTemp(row) {
      if (row.subType) {
        this.expectParam = {
          subType: row.subType
        }
      } else this.expectParam = null
      this.importUrl = `${row.importUrl}`
      this.iImport()
    },
    // 组织管理--打开导入对话框
    iImport() {
      this.importShow = true
    },
    //上传附件关闭对话框
    beforeCloseImportAttach() {
      if (this.fileList.length) {
        const params = []
        const url = '${data}/system/attachment_library/'
        const list = []

        this.fileList.forEach((e) => {
          if (list.indexOf(e.name) < 0) {
            list.push(e.name)
          }
          const obj = {
            deleted: 0,
            file_id: e.response.fileId,
            file_name: e.name,
            file_type: e.type,
            id: e.response.fileId,
            size: e.size,
            sub_type: this.subType
          }
          params.push(obj)
        })
        if (list.length != this.fileList.length) {
          this.$message.error('附件名称不能重复,请修改')
        } else {
          this.$http.post(url, params).then((res) => {
            if (res.data.state) {
              this.$message.success('操作成功')
              this.importAttachShow = false
            }
          })
        }
      } else this.importAttachShow = false
    },
    // 组织管理--关闭导入对话框
    beforeCloseImport() {
      this.importShow = false
    },
    input(value) {
      if (value) {
        this.fileList = JSON.parse(value)
      } else {
        this.fileList = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-table td {
  border-bottom: 0;
  padding: 0;
}
</style>
